import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VeeValidate, { Validator } from 'vee-validate';
import tr from 'vee-validate/dist/locale/tr';

Vue.use(VeeValidate);
Validator.localize('tr', tr);

Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: "AIzaSyBBvYJIR44YvXIVKsPT4Q7yxUDWhoTA3ag",
  authDomain: "real-career.firebaseapp.com",
  databaseURL: "https://real-career.firebaseio.com",
  projectId: "real-career",
  storageBucket: "real-career.appspot.com",
  messagingSenderId: "303084283192",
  appId: "1:303084283192:web:18697c452347226547cdcd"
};

Vue.component("loading", Loading);

firebase.initializeApp(firebaseConfig);

export const fs = firebase.firestore();
export const str = firebase.storage();

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");